import React, {Component} from 'react';
import qs from 'query-string';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import { Row, Col, Form, Icon, Input, Button } from 'antd';
import {fetchTokenData, signupUser} from '../actions';

const FormItem = Form.Item;

class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmDirty: false,
            serverErrors: {}
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.error && !prevState.serverErrors.error) {
            return {serverErrors: nextProps.error}
        }
        if (!nextProps.error && prevState.serverErrors.error) {
            return {serverErrors: {}}
        }
        return null;
    }
    handleServerError(values) {
        const {state: {serverErrors: {error, message}}, props: {form}} = this;
        if (!error) {
            return this.props.history.replace('/login');
        }
    }
    handleSubmit(e) {
        e.preventDefault();
        const {form, signupUser} = this.props;
        const {location: {search}} = this.props;
        const {token} = qs.parse(search);

        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            return signupUser({token, ...values}).then(() => this.handleServerError(values));
        });
    }
    compareToFirstPassword(rule, value, callback){
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('Two passwords that you enter is inconsistent!');
        } else {
            callback();
        }
    }
    validateToNextPassword(rule, value, callback){
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm'], { force: true });
        }
        callback();
    }

    componentDidMount() {
        const {fetchTokenData, location: {search}} = this.props;
        const {token, type} = qs.parse(search);
        return fetchTokenData(token, type);
    }

    render() {
        const {token: {name, email, isFetching}} = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <Row style={{ marginTop: '100px' }}>
                <Col md={{span: 10, offset: 7}} lg={{span: 8, offset: 8}} xl={{span: 6, offset: 9}}>
                    <Form onSubmit={this.handleSubmit.bind(this)} className="signup-form" style={{padding: '40px'}}>
                        <FormItem>
                            <Input disabled prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} value={email} />
                        </FormItem>
                        <FormItem hasFeedback>
                            {getFieldDecorator('password', {
                                rules: [
                                    { required: true, message: 'Please input your Password!' },
                                    { validator: this.validateToNextPassword.bind(this)}
                                ],
                            })(
                                <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
                            )}
                        </FormItem>
                        <FormItem hasFeedback>
                            {getFieldDecorator('password_confirmation', {
                                rules: [
                                    { required: true, message: 'Please confirm your Password!' },
                                    { validator: this.compareToFirstPassword.bind(this) }
                                ],
                            })(
                                <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Confirm Password" />
                            )}
                        </FormItem>
                        <FormItem>
                            <Button type="primary" htmlType="submit" className="login-form-button" style={{width: '100%'}}>
                                Sign Up
                            </Button>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        );
    }
}

const WrappedSignupForm = Form.create()(Signup);
const mapStateToProps = (state, ownProps) => {
    return {token: {...state.token}};
};
export default withRouter(connect(mapStateToProps, {fetchTokenData, signupUser})(WrappedSignupForm));


// WEBPACK FOOTER //
// ./resources/assets/js/components/Signup.js